import React, { useEffect, useState, useLayoutEffect } from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import Loader from "../Loader";
import {
  IPetPaymentProps,
  PetPaymentDetails,
  MESSAGES,
  PaymentParams,
} from "./PetPayment.types";
import "./PetPayment.scss";
import Config from "../../app-config";
import {
  getSalesJourneyForQuotes,
  updateTotalAmounts,
} from "../../util/data-store";
import {
  getRecaptchaToken,
  useFlowController,
  useFlowData,
  OptionToggle,
  FlowForm,
  subscribeDataChange,
  unsubscribeDataChange,
  IFlowFormControlDataChange,
  TickBox,
  Options,
  OptionalLayout,
  OptionElementType,
  setFlowDataDirect,
  getFlowDataDirect,
  FlowTypes,
  handleSendKlaviyoEvents,
  getPetsyTracker
} from "@adaptis/flow-components";
import { createPolicy, getQuote } from "../../util/knose-api-wrapper";
import { IPet, CoverType } from "../../util/common-types";
import { logEvent, timeout } from "@adaptis/flow-components";
import { getPetIndexFromId, getAFXProfile, sendPostback } from "../../util/helper-functions";
import LoadingLightbox from "../LoadingLightbox";
import { Button, Image } from "react-bootstrap";

export default function PetPayment(props: IPetPaymentProps) {
  //const [paymentDetails, setPaymentDetails] = useState<PetPaymentDetails>({ type: 'Direct', account_name: '', bsb: '', account_number: '', expiry_date: '', cvv: '' });
  const [selectedMethod, setSelectedMethod] = useState("Credit");
  const [errors, setErrors] = useState<PetPaymentDetails>({
    type: "",
    account_name: "",
    bsb: "",
    account_number: "",
    expiry_date: "",
    cvv: "",
  });
  const [validPaywayForm, setValidPaywayForm] = useState<boolean>();
  const [loadingPrice, setLoadingPrice] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [creditCardFrame, setCreditCardFrame] = useState<any>(null);
  const { nextStep, gotoStep, nextStepWithUrlParam } = useFlowController();
  const [policyNumber, setPolicyNumber] = useState(String);
  const [paymentError, setPaymentError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(String);
  const [salesJourneyId, setSalesJourneyId] = useState(String);
  const [customerId, setCustomerId] = useState(String);
  const paymentDiv = React.useRef<HTMLDivElement>(null);
  const { getData, setData, getDataFromArray } = useFlowData();
  const [promoCodeList, setPromoCodeList] = React.useState<
    Array<FlowTypes.IFlowPromotionCode>
  >([]);
  var style = {
    "div.payway-card": {
      "background-color": "transparent",
      border: "none",
      padding: "0px",
      margin: "0px",
      width: "100% !important",
    },
    ".payway-card label": {
      color: "#212529",
      "line-height": "20px",
      "font-size": "16px",
    },
    ".payway-card legend": {
      color: "#212529",
      "line-height": "20px",
      "font-size": "16px",
    },
    ".payway-card input": {
      color: "#212529",
      "border-radius": "0",
      height: "52px",
      "padding-left": "15px",
      border: "none",
      "border-bottom": "2px solid #f1f0f3",
      "box-shadow": "none",
      "font-size": "1rem",
    },
    ".payway-card input:focus": {
      border: "none",
      "border-bottom": "2px solid #1b0c3c",
      "box-shadow": "none",
    },
    ".payway-card select": {
      color: "#495057",
      "border-radius": "0",
      height: "52px",
      "padding-left": "10px",
      "border-top": "none",
      "border-left": "none",
      "border-right": "none",
      "border-bottom": "solid 2px #f1f0f3",
      "text-align": "start",
    },
    ".payway-card select:focus": {
      "border-top": "none",
      "border-left": "none",
      "border-right": "none",
      "border-bottom": "2px solid #1b0c3c",
      "box-shadow": "none",
    },
    "input.payway-complete": {
      "border-top": "none !important",
      "border-left": "none !important",
      "border-right": "none !important",
      "border-bottom": "solid 1px green !important",
    },
    "fieldset.payway-complete select": {
      "border-top": "none !important",
      "border-left": "none !important",
      "border-right": "none !important",
      "border-bottom": "solid 1px green !important",
    },
    "input.payway-error": {
      "border-top": "none !important",
      "border-left": "none !important",
      "border-right": "none !important",
      "border-bottom": "solid 2px #f04438 !important",
      "background-color": "#fef3f2",
    },
    ".payway-type-read-only": {
      top: "-2rem !important",
      right: "3px !important",
      bottom: "unset !important",
      "border-radius": "4px",
      border: "solid 1px !important",
    },

    "*": {
      "-moz-box-sizing": "border-box !important",
      "-webkit-box-sizing": "border-box !important",
      "box-sizing": "border-box !important",
    },
    "label.payway-number": {
      width: "100% !important",
      "margin-left": "auto",
      "margin-right": "auto",
      position: "relative !important",
      "z-index": "1",
      "text-indent": "1rem",
      color: "#3a2a80",
      height: "5.25rem",
      top: "1rem",
      left: "unset !important",
    },

    ".payway-card label.payway-name input, .payway-card input.payway-csc": {
      background: "#efefef",
      "border-radius": "8px",
      height: "5.25rem",
      position: "relative !important",
      "font-weight": "bold",
      "z-index": "-1",
      top: "-2rem !important",
      color: "#3a2a80",
      "padding-top": "2rem",
      width: "100% !important",
      left: "unset !important",
      right: "unset !important",
      "font-size": "1.3rem !important",
    },

    ".payway-card label input.payway-complete": {
      border: "unset !important",
      "box-shadow": "unset !important",
    },

    ".payway-card input.payway-number-formatted": {
      background: "#efefef",
      "border-radius": "8px",
      height: "5.25rem",
      position: "relative !important",
      "font-weight": "bold",
      "z-index": "-1 !important",
      top: "-2rem !important",
      color: "#3a2a80",
      "padding-top": "2rem",
      "font-size": "1.3rem !important",
    },

    "label.payway-name": {
      width: "100% !important",
      "margin-left": "auto",
      "margin-right": "auto",
      position: "relative !important",
      "z-index": "1",
      "text-indent": "1rem",
      color: "#3a2a80",
      height: "5.25rem",
      top: "1rem !important",
      left: "unset !important",
      right: "unset !important",
      "text-align": "left !important",
    },

    "label.payway-csc": {
      width: "100% !important",
      "margin-left": "auto",
      "margin-right": "auto",
      position: "relative !important",
      "z-index": "1",
      "text-indent": "1rem",
      color: "#3a2a80",
      height: "5.25rem",
      top: "0.7rem !important",
      left: "unset !important",
      right: "unset !important",
      "text-align": "left !important",
    },

    ".payway-card .payway-expiration": {
      "margin-left": "auto",
      "margin-right": "auto",
      "z-index": "-1",
      "text-indent": "1rem",
      color: "#3a2a80",
      height: "6.25rem",
      width: "100% !important",
      position: "relative !important",
      left: "unset !important",
      right: "unset !important",
      "text-align": "left !important",
      bottom: "0",
      background: "rgb(239, 239, 239)",
      "border-radius": "8px",
      top: "1.7rem !important",
    },

    ".payway-card .payway-expiration legend": {
      position: "relative !important",
      color: "#3a2a80",
      top: "1.3rem",
    },

    ".payway-card .payway-expiration select": {
      background: "#efefef",
      "z-index": "0",
      top: "1rem !important",
      color: "#3a2a80",
      "font-size": "1.3rem !important",
    },

    ".payway-card .payway-expiration.payway-complete select": {
      "font-weight": "bold",
      "font-size": "1.3rem !important",
      border: "unset !important",
    },
    ".payway-card .payway-expiration.payway-complete select:focus": {
      border: "unset !important",
      "box-shadow": "unset !important",
    },

    ".payway-card .payway-expiration.payway-error select": {
      border: "unset !important",
      "box-shadow": "unset !important",
    },

    ".payway-card .payway-expiration.payway-error": {
      "border-bottom": "2px solid rgb(240, 68, 56) !important",
    },

    ".payway-card .payway-expiration .payway-month, .payway-card .payway-expiration .payway-year": {
      width: "40% !important",
      "margin-right": "0.5rem",
    },

    ".payway-number-formatted": {
      width: "100% !important",
    },
    ".payway-card div.payway-creditcard-testfacility": {
      left: "0 !important",
      top: "-2rem !important",
    },

    ".payway-card .payway-creditcard-expirationseparator": {
      top: "-1rem",
      left: "50%",
      "font-size": "2rem",
      position: "relative !important",
    },
    "#payway-creditcard-form": {
      padding: "2rem 0rem 0rem 0rem",
      "margin-top": "-0.9rem",
    },

    ".payway-card label.payway-number": {
      top: "2rem !important",
    },

    ".payway-creditcard": {
      "padding-top": "1rem",
    },

    "@media (max-width: 576px)": {
      "#payway-creditcard-form": {
        padding: "2rem 0rem 0rem 0rem",
      },

      ".payway-card label.payway-number": {
        top: "2rem !important",
      },

      ".payway-creditcard": {
        "padding-top": "1rem",
      },

      ".payway-card .payway-expiration": {
        top: "1.7rem !important",
      },
      ".payway-card .payway-csc": {
        top: "0.4rem !important",
      },
    },
  };

  const options = {
    publishableApiKey: Config.payway_api_key,
    tokenMode: "callback",
    style,
    layout: "narrow", // narrow, wide
    onValid: onValidCCFrameCallback,
    onInvalid: onInvalidCCFrameCallback,
  };

  function ErrorModal(props: ModalProps) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Quote Error
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Something went wrong while getting your quote. There may be a
            problem connecting to the Internet.
          </p>
          <p>
            Click the Retry button below to try again or you can call us on{" "}
            <b>
              <a href="tel:1300 952 790">1300 952 790</a>
            </b>{" "}
            or email us at{" "}
            <b>
              <a href="mailto:hello@petsy.com.au">hello@petsy.com.au</a>
            </b>
            .
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              setShowErrorModal(false);
              callPreBidding();
            }}
          >
            Retry
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function onValidCCFrameCallback() {
    setValidPaywayForm(true);
  }

  function onInvalidCCFrameCallback() {
    console.log(
      "PetPayment.onInvalidCCFrameCallback selectedmethod=" + selectedMethod
    );
    setValidPaywayForm(false);
  }

  function createdCallback(err: any, frame: any) {
    if (err) {
      console.error("Error creating frame: " + err.message);
    } else {
      // Save the created frame for when we get the token
      setCreditCardFrame(frame);

      subscribeDataChange(props.clickNotification, () => {
        handleClickNotification(frame);
      });
    }
  }

  useLayoutEffect(() => {
    if (selectedMethod == "Credit") {
      setData("selectedMethod", "Credit");
    }

    //Set pre-bindding
    callPreBidding();
  }, []);

  useEffect(() => {
    //setData("selectedMethod", selectedMethod);
    if (selectedMethod == "Credit") {
      setData(props.dataField ?? "", validPaywayForm);
    } else {
      setData(props.dataField ?? "", false);
      onFormDataChange({ field: "", value: "" });
    }
  }, [selectedMethod]);

  useEffect(() => {
    if (selectedMethod == "Credit") {
      setData(props.dataField ?? "", validPaywayForm);
      setData("selectedMethod", "Credit");
    }
  }, [validPaywayForm]);

  const getPromotionCodes = async () => {
    try {
      const response = await fetch('/images/promotion-code.json', {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }

      const PromotionCodes = await response.json();
      let promoCodes = PromotionCodes as Array<FlowTypes.IFlowPromotionCode>;
      setPromoCodeList(promoCodes);
      setFlowDataDirect("root.promotion.code", PromotionCodes);
    } catch (err: any) {
      console.log("Read json file failed: ", err.message);
    }
  }

  const callPreBidding = async () => {
    setShowErrorModal(false);
    setLoadingPrice(true);
    let allPets = getData("root.pets");
    const timeoutError = Symbol();
    let quoteBindding;
    const result = await timeout(
      getQuote(allPets, 'bindding'),
      Config.websevice_timeout,
      timeoutError
    );
    if (!result || !result.data || (result.data.process != result.data.total)) {
      setLoadingPrice(false);
      setShowErrorModal(true);
      throw ["Error quote result is invalid", result];
    }
    setLoadingPrice(false);
    //store bindding data
    quoteBindding = result.data.quote;
    setFlowDataDirect("mmSessionId", quoteBindding.sessionId);

    try {
      await handleSendKlaviyoEvents("Step_5");
    } catch (error: any) {
      await logEvent(
        "error",
        true,
        "PetPayment->handleProcessPayment() - Send klaviyo event " +
        error.message
      );
    }
  }

  useEffect(() => {
    // Get promotions code
    let promoCodes = getFlowDataDirect("root.promotion.code");
    if (!promoCodes || !promoCodes.length) {
      getPromotionCodes();
    } else {
      setPromoCodeList(promoCodes as Array<FlowTypes.IFlowPromotionCode>);
    }
    let policyNumber = getData(props.policyNumberDataField);
    if (policyNumber && policyNumber.length > 0) {
      setData(props.policyNumberDataField, null);
      setData("pets", null);
      setData("salesJourneyId", null);
      gotoStep(props.firstStep);
      return;
    } else {
      console.log(
        "PetPayment.useEffect policyNumber is undefined - continuing"
      );
    }

    setCreditCardFrame(null);
    //setSelectedMethod("Direct");
    setValidPaywayForm(false);
    // sets the dataField being used for form validation to false on page load
    setData(props.dataField ?? "", false);

    // subscribe to the clickNotifiction field, if it exists
    if (props.clickNotification) {
      setData(props.clickNotification, false);
    }

    try {
      const payway = (window as any).payway;
      if (payway !== undefined && payway !== null) {
        payway.createCreditCardFrame(options, createdCallback);
      } else {
        throw new Error("window.payway is undefined");
      }
    } catch (err: any) {
      console.error("PetPayment: Payway / createCreditCardFrame failed", err);
      setPaymentError(true);
      setErrorMessage(
        "The secure card form could not be loaded. Please refresh the page or check that payment scripts are not blocked."
      );
      void logEvent(
        "error",
        true,
        "PetPayment->createCreditCardFrame",
        err?.message ?? String(err)
      );
    }
    setValidPaywayForm(false);

    let pets = getData("pets");
    updatePetsTotalPaymentDetails(pets);
    onFormDataChange({ field: "", value: "" });

    return () => {
      // Anything in here is fired on component unmount.
      if (creditCardFrame) {
        creditCardFrame.destroy();
      }

      setCreditCardFrame(null);
      if (props.clickNotification) {
        unsubscribeDataChange(props.clickNotification);
      }
    };
  }, []);

  useEffect(() => {
    // Anything in here is fired on component mount.
    subscribeDataChange("SelectedPaymentMethod", handleOptionChange);

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange("SelectedPaymentMethod");
    };
  }, [selectedMethod]);

  function updateTotalDiscount() {
    let currentPromoCode = getData("root.promoCode");

    if (!currentPromoCode) return;

    let filteredPromoCode: Array<FlowTypes.IFlowPromotionCode> = promoCodeList.filter(
      (promoCode: FlowTypes.IFlowPromotionCode) =>
        promoCode.promoCode.toLowerCase() === currentPromoCode.toLowerCase()
    );

    if (filteredPromoCode.length === 0) {
      return;
    }

    if (filteredPromoCode[0].type == 2) {
      let installmentAmount = getData("totalAmounts.installmentAmount");
      let totalDiscount = 0;

      if (filteredPromoCode[0].discount) {
        totalDiscount =
          installmentAmount -
          (filteredPromoCode[0].discount != "free"
            ? parseFloat(filteredPromoCode[0].discount)
            : 0);
      } else {
        totalDiscount =
          ((filteredPromoCode[0].percent ?? 0) / 100) * installmentAmount;
      }
      setData("totalAmounts.totalDiscount", totalDiscount);
    }

    setData("campaignName", filteredPromoCode[0].campaignName ?? "");
  }

  async function updatePetsTotalPaymentDetails(pets: any) {
    updateTotalAmounts();
    updateTotalDiscount();

    setData(
      "holderFullName",
      `${getData("holderFirstName")} ${getData("holderLastName")}`
    );
    setData(
      "holderAddressState",
      `${getData("holderAddress.suburb")}, ${getData("holderAddress.state")}`
    );
  }

  function isValidation() {
    let localErrors: PetPaymentDetails = {
      type: "",
      account_name: "",
      bsb: "",
      account_number: "",
      expiry_date: "",
      cvv: "",
    };
    setErrors(localErrors);

    var isError = false;
    let isValidPaywayForm = getData(props.dataField ?? "");
    let localSelectedMethod = getData("selectedMethod");

    if (localSelectedMethod === "Direct") {
      let accountName = getData("accountName");
      accountName = accountName ? accountName.trim() : accountName;
      let BSB = getData("bsb");
      BSB = BSB ? BSB.trim() : BSB;
      let accountNumber = getData("accountNumber");
      accountNumber = accountNumber ? accountNumber.trim() : accountNumber;
      if (accountName == undefined || accountName.length < 3) {
        isError = true;
        localErrors["account_name"] = MESSAGES.ERROR_PAYMENT_CREDIT_FORM;
      }
      if (BSB == undefined || BSB.length < 6) {
        isError = true;
        localErrors["bsb"] = MESSAGES.ERROR_PAYMENT_CREDIT_FORM;
      }
      if (accountNumber == undefined || accountNumber.length < 5) {
        isError = true;
        localErrors["account_number"] = MESSAGES.ERROR_PAYMENT_CREDIT_FORM;
      }
    } else {
      if (!isValidPaywayForm) {
        isError = true;
        localErrors["account_number"] = MESSAGES.ERROR_PAYMENT_CREDIT_FORM;
      }
    }

    if (isError) {
      setErrors(localErrors);
      let idErrorElement = "";
      if (JSON.stringify(localErrors) !== "{}") {
        idErrorElement = Object.keys(localErrors)[0];
      }
      return false;
    }
    return true;
  }


  function handleClickNotification(iframe: any) {
    let clickNotification = getData(props.clickNotification);
    if (clickNotification) {
      handleSubmit(iframe);
      setData(props.clickNotification, false);
    }
  }

  async function handleSubmit(iframe: any) {
    if (!isValidation()) {
      return false;
    }

    setLoading(true);
    let isError: Boolean;
    let params: PaymentParams = {
      customerId: "",
      paymentGatewayId: 0,
      accountName: "",
      tokenInformation: "",
      bankCode: "",
      accountNumber: "",
    };

    let localSelectedMethod = getData("selectedMethod");
    // console.log("handleProcessPayment 11.0: ", localSelectedMethod);
    if (localSelectedMethod === "Credit") {
      const time0 = performance.now();

      if (iframe != undefined) {
        iframe.getToken(async function (err: any, data: any) {
          if (err) {
            console.error(
              "PetPayment.handleSubmit() Error getting PayWay token: " +
              err.message
            );
            setLoading(false);
            isError = true;
            let localErrors = { ...errors };
            localErrors.account_name = err.message;
            setErrors(localErrors);
            return;
          }

          const time1 = performance.now();
          console.log(
            `PetPayment.handleSubmit() PayWay token received in ${time1 - time0
            } milliseconds.`
          );
          console.log("handleProcessPayment 0.0: ", data);
          params.paymentGatewayId = 5;
          params.tokenInformation = data.singleUseTokenId;
          params.accountName = data.creditCard.cardholderName;
          handleProcessPayment(params);
        });
      }
    } else {
      // console.log("handleProcessPayment 0.1: ", params);
      params.paymentGatewayId = 4;
      let bsb = getData("bsb");
      params.bankCode = `${bsb.slice(0, 3)}-${bsb.slice(3)}`; // Inser a - in the middle
      let accountNumber = getData("accountNumber");
      accountNumber = accountNumber ? accountNumber.trim() : accountNumber;
      let accountName = getData("accountName");
      accountName = accountName ? accountName.trim() : accountName;
      params.accountNumber = accountNumber;
      params.accountName = accountName;
      handleProcessPayment(params);
    }
  }

  async function handleProcessPayment(params: PaymentParams) {
    const time0 = performance.now();
    let time1 = 0;
    let time2 = 0;
    let time3 = 0;

    try {
      let isError = false;
      let quotations: any = {};
      let sessionId = getData("mmSessionId");
      let paymentPype = "direct_debit";
      let paymentDetails: any = {};
      // console.log("handleProcessPayment 1.0: ", params);      
      let localSelectedMethod = getData("selectedMethod");
      // console.log("handleProcessPayment 1: ", localSelectedMethod);
      if (localSelectedMethod === 'Credit') {
        paymentPype = 'credit_card';
        paymentDetails = {
          token_info: params.tokenInformation,
          account_name: params.accountName
        }
      } else {
        paymentDetails = {
          bsb_code: params.bankCode,
          account_number: params.accountNumber,
          account_name: params.accountName
        }

      }

      // build the quotations array
      const pets = getData("pets");

      let isFailedPayment = true;
      let lpolicyNumber = "";
      let errorMessage = "";
      // console.log("handleProcessPayment 2: ", paymentDetails);
      let createPolicyResult = await createPolicy(sessionId, paymentPype, paymentDetails);
      let policyResult = createPolicyResult?.data ?? null;
      let fdclid = getData("fdclid") ?? "";
      let promises: any[] = [];
      console.log("[PPP-223] fdclid", fdclid);
      if (policyResult && policyResult.policy) {
        isFailedPayment = false;
        let petsPolicy = policyResult.policy.pets;
        petsPolicy.forEach((policy: any) => {
          lpolicyNumber = policy.policyNumber;
          setPolicyNumber(lpolicyNumber);
          let petIndex = getPetIndexFromId(policy.pet_no, pets);
          setData(`pets[${petIndex}].policyNumber`, policy.policyNumber);
        });
        await logEvent(
          "save-quote-fields",
          true,
          getAFXProfile()
        );
      }

      if (isFailedPayment) {
        console.log(
          `PetPayment.handleProcessPayment() errorMessage=${errorMessage}, policyNumber=${policyNumber}`
        );
      }
      if (!isFailedPayment && lpolicyNumber) {
        setPolicyNumber(lpolicyNumber);
        setData(props.policyNumberDataField, lpolicyNumber);
        // nextStep();
        let promisesKlaviyo: any[] = [];
        try {
          promisesKlaviyo.push(handleSendKlaviyoEvents("PURCHASED"));
          // promisesKlaviyo.push(handleSendKlaviyoEvents("Policy_Purchase_Success"));
          await Promise.all(promisesKlaviyo);
        } catch (error: any) {
          await logEvent(
            "error",
            true,
            "PetPayment->handleProcessPayment() - Send klaviyo event " +
            error.message
          );
        }

        nextStepWithUrlParam("/success?id=" + getData("root.sessionId"));
        setLoading(false);
      } else if (!lpolicyNumber) {
        setPaymentError(true);
        setLoading(false);
        setErrorMessage(
          MESSAGES.ERROR_CREATE_POLICY.replaceAll("*error*", errorMessage)
        );

        setTimeout(() => window.scrollTo(0, 0), 200); // Need to dealy to make the scroll work

        // logEvent(
        //   "error",
        //   true,
        //   "PetPayment->handleProcessPayment() - Failed Create Policy. " +
        //   errorMessage,
        //   processBatchParams,
        //   bindBatch
        // );
      } else {
        setPaymentError(true);
        setLoading(false);
        setErrorMessage(
          MESSAGES.ERROR_CREATE_POLICY.replaceAll("*error*", errorMessage)
        );
        setTimeout(() => window.scrollTo(0, 0), 200); // Need to dealy to make the scroll work

        // logEvent(
        //   "error",
        //   true,
        //   "PetPayment->handleProcessPayment() - Failed Payment. " +
        //   errorMessage,
        //   processBatchParams,
        //   bindBatch
        // );
      }
    } catch (e: any) {
      logEvent(
        "error",
        true,
        "PetPayment->handleProcessPayment() - Payment exception. ",
        e
      );
      setLoading(false);
      console.log("Payment exception", e);
    }

    time3 = performance.now();
    console.log(
      `PetPayment.handleProcessPayment() COMPLETED in ${time3 - time0
      } milliseconds.`
    );
  }

  function handleOptionChange(dataPath: string, dataField: string, data: any) {
    if (dataField === "selectedMethod" && data != selectedMethod) {
      setSelectedMethod(data);
    }
  }

  function onFormDataChange(dataChange: IFlowFormControlDataChange) {
    if (selectedMethod == "Direct") {
      let accountName = getData("accountName");
      let bsb = getData("bsb");
      let accountNumber = getData("accountNumber");

      let isValid = true;
      if (accountName == undefined || accountName.length < 3) {
        isValid = false;
      }
      if (bsb == undefined || bsb.length < 6) {
        isValid = false;
      }
      if (accountNumber == undefined || accountNumber.length < 6) {
        isValid = false;
      }
      setData(props.dataField ?? "", isValid);
    }
  }

  const optionToggleList = [
    {
      value: "Credit",
      label: "Credit card",
    },
    {
      value: "Direct",
      label: "Direct debit",
    },
  ];

  const formConfig = [
    {
      id: "accountName",
      type: "text",
      prompt: "Account Name",
      maxLength: 50,
      required: true,
      dataField: "accountName",
      invalidMessage: "Please enter an Account name",
      dataPrivate: true,
    },
    {
      id: "bsb",
      type: "text-mask",
      prompt: "BSB",
      required: true,
      dataField: "bsb",
      mask: "111-111",
      invalidMessage: "Please enter an valid BSB number",
      dataPrivate: true,
    },
    {
      id: "accountNumber",
      type: "number",
      prompt: "Account number",
      maxLength: 10,
      required: true,
      dataField: "accountNumber",
      invalidMessage: "Please enter an valid Account number",
      dataPrivate: true,
      autocomplete: 'off'
    },
  ];

  const optionList = [
    {
      dataValue: "Credit",
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: "Credit/Debit card",
        },
      ],
    },
    {
      dataValue: "Direct",
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: "Direct debit",
        },
      ],
    },
  ];
  return (
    <div id="main" className="flc_pet-payment" ref={paymentDiv}>
      <div className="row">
        <div className="col-12 col-left">
          <div className="form-content">
            {props && (
              <Options
                dataField="selectedMethod"
                layout={OptionalLayout.OneLine}
                optionList={optionList}
                stepSlug={""}
              />
            )}

            {paymentError && (
              <div className="errorsDiv">
                <div>{errorMessage} </div>
              </div>
            )}

            <div className="form-group"></div>
            <div
              className={`payment-direct${selectedMethod === "Credit" ? " d-none" : ""
                }`}
            >
              <div className="direct-debit">
                <span className="text-style-2 ">Direct Debit Details</span>
              </div>
              <FlowForm
                formConfig={formConfig}
                stepSlug={props.stepSlug}
                onChange={onFormDataChange}
              />
            </div>
            <div
              className={`payment-direct ${selectedMethod === "Direct" ? " d-none" : ""
                }`}
            >
              <div className="credit-card">
                <span className="text-style-2">Credit Card Details</span>
              </div>
              <div id="payway-credit-card"></div>
            </div>
          </div>
        </div>
        <div className="row"> &nbsp; </div>
      </div>
      <PaymentProcessingModal show={loading} />
      <LoadingLightbox show={loadingPrice} title="Loading..." />
      <ErrorModal show={showErrorModal} />
    </div>
  );
}

function PaymentProcessingModal(props: ModalProps) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Processing Payment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Loader className="loader" />
        <p>Please hang tight while we process your payment</p>
      </Modal.Body>
    </Modal>
  );
}
